import { z } from "zod";
import { INCIDENT_PRIORITIES } from "./enums.js";
export const PASSWORD_MIN_LENGTH = 12;
export const PASSWORD_MAX_LENGTH = 128;
export const PASSWORD_REQUIREMENT = "Use 12–128 characters.";
export const passwordSchema = z
    .string()
    .min(PASSWORD_MIN_LENGTH, "Password must be at least 12 characters.")
    .max(PASSWORD_MAX_LENGTH, "Password cannot exceed 128 characters.");
export const loginInputSchema = z.object({
    email: z.email().transform((value) => value.toLowerCase()),
    password: passwordSchema
});
export const registerStartInputSchema = loginInputSchema.extend({
    name: z.string().trim().min(2).max(80)
});
export const registerInputSchema = registerStartInputSchema.extend({
    organisationName: z.string().trim().min(2).max(100),
    workspaceName: z.string().trim().min(2).max(100)
});
export const verifyRegistrationInputSchema = z.object({
    challengeId: z.string().min(1),
    code: z.string().regex(/^\d{6}$/)
});
export const resendRegistrationInputSchema = z.object({ challengeId: z.string().min(1) });
export const tenantNameInputSchema = z.object({
    name: z.string().trim().min(2).max(100)
});
const slaTargetSchema = z.object({
    acknowledgeMinutes: z.number().int().min(1).max(43_200),
    resolveMinutes: z.number().int().min(1).max(525_600)
});
export const slaPolicySchema = z.object(Object.fromEntries(INCIDENT_PRIORITIES.map((priority) => [priority, slaTargetSchema])));
export const THEME_PREFERENCES = ["system", "light", "dark"];
export const accountPreferencesSchema = z.object({
    theme: z.enum(THEME_PREFERENCES),
    inApp: z.object({
        incidentAssigned: z.boolean(),
        incidentUpdated: z.boolean(),
        incidentCommented: z.boolean()
    })
});
